import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import axios from 'axios';

const CreateDemoAccount = () => {
    const [form, setForm] = useState({ name: '', email: '', password: '' });
    const [message, setMessage] = useState('');

    const handleChange = e => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/create-demo-account`, form);
            setMessage('✅ Demo account created successfully');
        } catch (err) {
            setMessage(`❌ ${err.response?.data?.error || 'Failed to create account'}`);
        }
    };

    return (
        <Box p={4} bgcolor="#1c1c1c" borderRadius={2} maxWidth="500px" margin="auto">
            <Typography variant="h5" mb={2} color="#fff">Create Demo Account</Typography>
            <TextField
                label="Name"
                name="name"
                value={form.name}
                onChange={handleChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ style: { color: '#12c099' } }}
                sx={{ input: { color: '#fff' }, backgroundColor: '#202020' }}
            />
            <TextField
                label="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ style: { color: '#12c099' } }}
                sx={{ input: { color: '#fff' }, backgroundColor: '#202020' }}
            />
            <TextField
                label="Password"
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ style: { color: '#12c099' } }}
                sx={{ input: { color: '#fff' }, backgroundColor: '#202020' }}
            />
            <Button onClick={handleSubmit} variant="contained" sx={{ mt: 2, backgroundColor: '#12c099', color: '#000' }}>
                Create Account
            </Button>
            {message && <Typography mt={2} color="#fff">{message}</Typography>}
        </Box>
    );
};

export default CreateDemoAccount;
